"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentAclFilter = void 0;
var constants_1 = require("@hobt/constants");
var document_acl_role_1 = require("../document/document-acl-role");
/**
 * @param accessCondition
 * @param userContext
 * @param role
 * @returns
 */
exports.documentAclFilter = function (accessCondition, userContext, userid, role) {
    if (userid === void 0) { userid = ''; }
    if (role === void 0) { role = constants_1.UserRole.ReadOnly; }
    switch (accessCondition) {
        case document_acl_role_1.DocumentAclRole.AUTHOR:
            return userContext.homeownerID === userid;
        case document_acl_role_1.DocumentAclRole.INTERNAL:
            return userContext.userTypeCode === constants_1.UserType.Internal;
        case document_acl_role_1.DocumentAclRole.EXTERNAL:
            return userContext.userTypeCode === constants_1.UserType.External;
        case document_acl_role_1.DocumentAclRole.MASTER_USER:
            return userContext.userTypeCode === constants_1.UserType.Internal && role === constants_1.UserRole.MasterUser;
        default:
            return false;
    }
};
